import 'parsleyjs';

export default function (el, htmlOptions) {
    // do something at least
}
